import React from "react";

type WowMainLineProps = {
    selected: boolean;
    progress: number;
    click: (ind: number) => void;
    myIndex: number;
};

class WowMainLine extends React.Component<WowMainLineProps> {
    clickMe = () => {
        this.props.click(this.props.myIndex);
    };

    render() {
        const { selected, progress } = this.props;
        return (
            <div className="wow-main-line-container" onClick={this.clickMe}>
                <div className={`wow-main-line ${selected ? "wow-main-selected" : ""}`}>
                    <div className="wow-main-line-box" style={{ width: `${progress * 100}%`, transition: "width 0.2s linear" }} />
                </div>
            </div>
        );
    }
}

export { WowMainLine };
